import { Injectable, Injector, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { requiresRoleSelection, UserStore } from 'src/app/auth/services/user.store';
import { AuthService } from '../services/auth.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Observable, of } from 'rxjs';
import { catchError, filter, finalize, map, take, timeout } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  router = inject(Router);
  private userStore = inject(UserStore);
  authService = inject(AuthService);
  private ntf = inject(NotificationService);
  private injector = inject(Injector);

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isAuthenticated()) {
      this.ntf._showNotification('snackbar-info', 'needAuth');
      return this.router.createUrlTree(['/authentication/signin'], {
        queryParams: { redirectUrl: state.url },
      });
    }

    if (this.userStore.isStoreReady()) {
      return this.checkAccess();
    }
    this.ntf.showLoader();
    return toObservable(this.userStore.isStoreReady, { injector: this.injector }).pipe(
      filter(Boolean),
      take(1),
      timeout(10_000),
      catchError(() => of(true)),
      map(() => this.checkAccess()),
      finalize(() => this.ntf.hideLoader())
    );
  }

  private checkAccess(): boolean | UrlTree {
    const user = this.userStore.user();
    if (user && requiresRoleSelection(user.roles)) {
      return this.router.createUrlTree(['/role-selection']);
    }
    return true;
  }
}
